import { render, staticRenderFns } from "./HomeSnippet.vue?vue&type=template&id=09466297&scoped=true"
import script from "./HomeSnippet.vue?vue&type=script&lang=text%2Fjavascript"
export * from "./HomeSnippet.vue?vue&type=script&lang=text%2Fjavascript"
import style0 from "./HomeSnippet.vue?vue&type=style&index=0&id=09466297&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09466297",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppStoreReviewBlock: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/about/AppStoreReviewBlock.vue').default})
